import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const getAuthHeader = () => {
  const user = authService.getCurrentUser();
  if (user && user.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
};

const perfilService = {
  obterPerfil: async () => {
    try {
      const response = await axios.get(`${API_URL}/perfil/`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: "Erro ao obter dados do perfil" };
    }
  },

  atualizarPerfil: async (dados) => {
    try {
      const response = await axios.put(`${API_URL}/perfil/`, dados, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: "Erro ao atualizar perfil" };
    }
  },

  alterarSenha: async (senhas) => {
    try {
      const response = await axios.post(
        `${API_URL}RedefinicaoDeSenha/alterar-senha-autenticado`,
        senhas,
        {
          headers: getAuthHeader(),
        },
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: "Erro ao alterar senha" };
    }
  },
};

export default perfilService;
